/* eslint-disable import/prefer-default-export */
import get from 'lodash/get';

export const getFullAddressWithArea = (address, area, withSpace) => {
  const state = get(area, 'state');
  const country = get(area, 'country');
  const province = get(area, 'province');
  return [address, province, state, country]
    .filter((value) => !!value)
    .join(withSpace ? ' ' : ', ');
};
